import type { Place } from './types';

// Logic thuần của form Sửa / Thêm điểm (board Mint-TMS-Places, drawers.place): giờ cấm tải, toạ độ, trùng 100 m.

/** Tách các khung "hh:mm–hh:mm" cách nhau dấu phẩy; `bad` = có khung sai. */
export function parseBan(s: string): { ok: string[]; bad: boolean } {
  const parts = s.split(',').map((x) => x.trim()).filter(Boolean);
  const ok: string[] = [];
  let bad = false;
  for (const p of parts) {
    const m = p.match(/^(\d{1,2}):(\d{2})\s*[–-]\s*(\d{1,2}):(\d{2})$/);
    const [, h1 = '', m1 = '', h2 = '', m2 = ''] = m ?? [];
    if (m && Number(h1) < 24 && Number(h2) < 24 && Number(m1) < 60 && Number(m2) < 60) ok.push(`${h1.padStart(2, '0')}:${m1}–${h2.padStart(2, '0')}:${m2}`);
    else bad = true;
  }
  return { ok, bad };
}

/** "10.76, 106.78" → [lat, lng]; sai khung VN → null. */
export function parseXY(s: string): [number, number] | null {
  const m = s.match(/(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{2,3}(?:\.\d+)?)/);
  return m ? [Number(m[1]), Number(m[2])] : null;
}

/** Khoảng cách (m) giữa hai toạ độ. */
export function haversine(la1: number, lo1: number, la2: number, lo2: number): number {
  const R = 6371000;
  const rad = (d: number) => (d * Math.PI) / 180;
  const a = Math.sin(rad(la2 - la1) / 2) ** 2 + Math.cos(rad(la1)) * Math.cos(rad(la2)) * Math.sin(rad(lo2 - lo1) / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export interface Dup { place: Place; metres: number }

/** Điểm khác trong 100 m quanh toạ độ nhập, gần trước. */
export function dupsOf(xy: string, all: readonly Place[], selfCode: string | null): Dup[] {
  const p = parseXY(xy);
  if (!p) return [];
  return all
    .filter((x) => x.code !== selfCode && x.lat != null && x.lng != null)
    .map((x) => ({ place: x, metres: Math.round(haversine(p[0], p[1], x.lat as number, x.lng as number)) }))
    .filter((d) => d.metres <= 100)
    .sort((a, b) => a.metres - b.metres);
}
